import { UrlKind, ValidatedUrlModule_create } from "../../HttpV2.js";
import { printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { map as map_1, value as value_13, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { CaseStrategy } from "../../fable_modules/Thoth.Json.10.2.0/Types.fs.js";
import { int32_type, bool_type, record_type, class_type, option_type, unit_type, string_type, equals } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { emptyFairUsageState, emptyActivationStateBarring, emptyActivationStateRoaming, ActivationState, emptyActivationStateCommon, emptyActivationState, FairUsageState, ActivationStateBarring, ActivationStateRoaming, CustomService, ActivationStateCommon, ActivationState$reflection } from "./Model.js";
import { Auto_generateBoxedDecoder_79988AEF, fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Lazy, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { getCsrfEnabledRequest, ValidatedUrlModule_value, addClientReference, Http_get_ExtraCoders } from "../../HttpV2.js";
import { Http_content, Http_request, Http_method, Http_withCredentials, Http_send } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Http.fs.js";
import { BodyContent, HttpMethod } from "../../fable_modules/Fable.SimpleHttp.3.0.0/Types.fs.js";
import { Auto_generateBoxedEncoder_Z20B7B430, toString } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { SelectOption, ValueProp as ValueProp_1, SelectOption_get_getDefault, selectOption } from "../../Components/FormFields/FormFields.js";
import { cons, empty, choose, map, singleton as singleton_2, append as append_1, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { TextProps$1, TextProps$1_GetDefault, render as render_1 } from "../../Components/StatefulFormFields/Text.js";
import { parseInt64, parseInt$ } from "../../Utils.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import * as react from "react";
import { ButtonProps, defaultProps, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { Elements_renderSideTable } from "../../Components/Table/Table.js";
import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { fromNumber, op_Division, fromBits, op_Multiply, toNumber } from "../../fable_modules/fable-library.3.7.20/Long.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useSelector } from "../../Redux/Store.js";
import { getTranslationFrom } from "../../Global.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { dotsLoading } from "../../ViewUtils.js";
import "../../../src/Containers/ActivationState/View.scss";


function API_loadActivationState(clientNr, contractTypeCode) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/contracttype/%i/%s/activationState"))(clientNr)(contractTypeCode)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(ActivationState$reflection(), string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(ActivationState$reflection(), arg_2, Http_get_ExtraCoders().Value)), str);
        });
        return singleton.Delay(() => singleton.Bind(Http_send(addClientReference(Http_withCredentials(true, Http_method(new HttpMethod(0), Http_request(ValidatedUrlModule_value(matchValue.fields[0])))))), (_arg) => {
            let response_1;
            return singleton.Return((response_1 = _arg, (response_1.statusCode === 200) ? (equals(ActivationState$reflection(), string_type) ? (new FSharpResult$2(0, response_1.responseText)) : parseFn(response_1.responseText)) : (new FSharpResult$2(1, response_1.responseText))));
        }));
    }
}

function API_saveActivationState(clientNr, contractTypeCode, state) {
    const matchValue = ValidatedUrlModule_create(new UrlKind(1, toText(printf("/contracttype/%i/%s/activationState"))(clientNr)(contractTypeCode)));
    if (matchValue.tag === 1) {
        return singleton.Return(new FSharpResult$2(1, matchValue.fields[0]));
    }
    else {
        const requestCaseStrategy_1 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        let parseFn;
        const arg_2 = defaultArg(new CaseStrategy(0), new CaseStrategy(0));
        parseFn = ((arg_1_1) => {
            const str = arg_1_1;
            return equals(unit_type, string_type) ? (new FSharpResult$2(0, str)) : fromString(uncurry(2, Auto_generateBoxedDecoder_79988AEF(unit_type, arg_2, Http_get_ExtraCoders().Value)), str);
        });
        const jsonStr = toString(0, Auto_generateBoxedEncoder_Z20B7B430(option_type(ActivationState$reflection()), requestCaseStrategy_1, Http_get_ExtraCoders().Value, false)(state));
        return singleton.Delay(() => {
            let a;
            return singleton.Bind((a = getCsrfEnabledRequest(addClientReference(Http_withCredentials(true, Http_content(new BodyContent(1, jsonStr), Http_method(new HttpMethod(1), Http_request(ValidatedUrlModule_value(matchValue.fields[0]))))))), singleton.Bind(a, Http_send)), (_arg) => {
                const response = _arg;
                return (response.statusCode === 200) ? singleton.Return(parseFn(response.responseText)) : singleton.Return(new FSharpResult$2(1, response.responseText));
            });
        });
    }
}

class Editor {
    constructor(getTranslation) {
        this.getTranslation = getTranslation;
    }
}

function Editor$reflection() {
    return class_type("Containers.ActivationState.View.Editor", void 0, Editor);
}

function Editor_$ctor_11D407F6(getTranslation) {
    return new Editor(getTranslation);
}

function Editor__get_notChangedText(this$) {
    return new Lazy(() => this$.getTranslation("Contracts.ContractType.ActivationState.ValueNotChanged"));
}

function Editor__get_valueSetTrue(this$) {
    return new Lazy(() => this$.getTranslation("Contracts.ContractType.ActivationState.ValueTrue"));
}

function Editor__get_valueSetFalse(this$) {
    return new Lazy(() => this$.getTranslation("Contracts.ContractType.ActivationState.ValueFalse"));
}

function Editor__get_errorNotaNumber(this$) {
    return new Lazy(() => this$.getTranslation("Contracts.ContractType.ActivationState.ValidationErrorNotANumber"));
}

function Editor__boolTriState(this$, label, onChange, value) {
    let inputRecord, OptionValues;
    return selectOption((inputRecord = SelectOption_get_getDefault(), (OptionValues = ofArray([["-", Editor__get_notChangedText(this$).Value], ["true", Editor__get_valueSetTrue(this$).Value], ["false", Editor__get_valueSetFalse(this$).Value]]), new SelectOption(new ValueProp_1(0, (value != null) ? (value ? "true" : "false") : "-", (x) => {
        let matchValue;
        onChange((matchValue = Browser_Types_Event__Event_get_Value(x), (matchValue === "true") ? true : ((matchValue === "false") ? false : (void 0))));
    }), inputRecord.Id, OptionValues, inputRecord.Classes, label, inputRecord.Disabled, inputRecord.HTMLProps))));
}

function Editor__optionalEditor(this$, label, onChange, value, format, parse) {
    let inputRecord, LabelText;
    return render_1()((inputRecord = TextProps$1_GetDefault(), (LabelText = ((value != null) ? label : Editor__get_notChangedText(this$).Value), new TextProps$1((value != null) ? format(value_13(value)) : "", inputRecord.Type, inputRecord.Classes, (e) => {
        onChange(parse(Browser_Types_Event__Event_get_Value(e)));
    }, inputRecord.Disabled, LabelText, inputRecord.Id, (x_1) => {
        const _arg = parse(x_1);
        return (_arg == null) ? (new FSharpResult$2(1, Editor__get_errorNotaNumber(this$).Value)) : (new FSharpResult$2(0, value_13(_arg)));
    }, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name))));
}

function Editor__optionalInt32Editor(this$, label, onChange, value) {
    let clo;
    return Editor__optionalEditor(this$, label, onChange, value, (clo = toText(printf("%i")), clo), parseInt$);
}

function Editor__optionalInt64Editor(this$, label, onChange, value) {
    let clo;
    return Editor__optionalEditor(this$, label, onChange, value, (clo = toText(printf("%i")), clo), parseInt64);
}

function Editor__optionalStringEditor(this$, label, onChange, value) {
    let clo;
    return Editor__optionalEditor(this$, label, onChange, value, (clo = toText(printf("%s")), clo), (_arg) => ((_arg === "") ? (void 0) : _arg));
}

function Editor__field(this$, isEdit, name, setter, value, editor, readOnlyValueFormatter) {
    return toList(delay(() => append(singleton_1(name), delay(() => {
        let children;
        return isEdit ? singleton_1(editor(name, setter, value)) : singleton_1((children = [(value == null) ? Editor__get_notChangedText(this$).Value : readOnlyValueFormatter(value_13(value))], react.createElement("span", {
            className: "Field",
        }, ...children)));
    }))));
}

function Editor__boolField(this$, isEdit, name, setter, value) {
    return Editor__field(this$, isEdit, name, setter, value, (arg_6, arg_7, arg_8) => Editor__boolTriState(this$, arg_6, arg_7, arg_8), (_arg) => (_arg ? Editor__get_valueSetTrue(this$).Value : Editor__get_valueSetFalse(this$).Value));
}

function Editor__int32Field(this$, isEdit, name, setter, value) {
    let clo;
    return Editor__field(this$, isEdit, name, setter, value, (arg_6, arg_7, arg_8) => Editor__optionalInt32Editor(this$, arg_6, arg_7, arg_8), (clo = toText(printf("%i")), clo));
}

function Editor__int64Field(this$, isEdit, name, setter, value) {
    let clo;
    return Editor__field(this$, isEdit, name, setter, value, (arg_6, arg_7, arg_8) => Editor__optionalInt64Editor(this$, arg_6, arg_7, arg_8), (clo = toText(printf("%i")), clo));
}

function Editor__stringField(this$, isEdit, name, setter, value) {
    let clo;
    return Editor__field(this$, isEdit, name, setter, value, (arg_6, arg_7, arg_8) => Editor__optionalStringEditor(this$, arg_6, arg_7, arg_8), (clo = toText(printf("%s")), clo));
}

function panelButton(isPrimary, text, onClick) {
    const children = [wrappedButton(isPrimary ? (new ButtonKind(0)) : (new ButtonKind(2)), new ButtonProps(text, defaultProps.Content, (e) => {
        onClick();
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon))];
    return react.createElement("span", {
        className: "mr-2 d-inline-block w-auto",
    }, ...children);
}

function columnTable(name, children) {
    const children_1 = [Elements_renderSideTable((x) => x, name, children)];
    return react.createElement("div", {
        className: "tables__table",
    }, ...children_1);
}

class CommonState extends Record {
    constructor(CustomServiceAddingId) {
        super();
        this.CustomServiceAddingId = CustomServiceAddingId;
    }
}

function CommonState$reflection() {
    return record_type("Containers.ActivationState.View.CommonState", [], CommonState, () => [["CustomServiceAddingId", string_type]]);
}

function renderCommon(getTranslation, isEdit, data, setData, commonState) {
    const Editor_1 = Editor_$ctor_11D407F6(getTranslation);
    return columnTable(getTranslation("Contracts.ContractType.ActivationState.CommonHeader"), append_1(ofArray([Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonData"), (value) => {
        setData(new ActivationStateCommon(value, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, data.customServices, data.volte));
    }, data.data), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonPublicIp"), (value_1) => {
        setData(new ActivationStateCommon(data.data, value_1, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, data.customServices, data.volte));
    }, data.dataPublicIp), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonVolte"), (value_2) => {
        setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, data.customServices, value_2));
    }, data.volte), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonMms"), (value_3) => {
        setData(new ActivationStateCommon(data.data, data.dataPublicIp, value_3, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, data.customServices, data.volte));
    }, data.mms), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonVoicemail"), (value_4) => {
        setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, value_4, data.customServices, data.volte));
    }, data.voicemail), Editor__int32Field(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonDatapackageInMb"), (value_5) => {
        setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, value_5, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, data.customServices, data.volte));
    }, data.datapackageInMb), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonDatapackageRollover"), (value_6) => {
        setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, value_6, data.datapackageSpeedInKbPerSec, data.voicemail, data.customServices, data.volte));
    }, data.datapackageRollover), Editor__int32Field(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.CommonDatapackageSpeedInKbPerSec"), (value_7) => {
        setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, value_7, data.voicemail, data.customServices, data.volte));
    }, data.datapackageSpeedInKbPerSec)]), append_1(singleton_2(ofArray([react.createElement("div", {}, "Custom Services"), react.createElement("div", {})])), append_1(map((c) => {
        let children_4, children_6;
        return ofArray([(children_4 = toList(delay(() => append(isEdit ? singleton_1(panelButton(false, "X", () => {
            setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, choose((x) => {
                if (x.id === c.id) {
                    return void 0;
                }
                else {
                    return x;
                }
            }, defaultArg(data.customServices, empty())), data.volte));
        })) : empty_1(), delay(() => singleton_1(c.id))))), react.createElement("div", {}, ...children_4)), (children_6 = toList(delay(() => {
            let matchValue;
            return isEdit ? singleton_1(Editor__boolTriState(Editor_1, c.id, (value_10) => {
                setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, map((x_1) => {
                    if (x_1.id === c.id) {
                        return new CustomService(x_1.id, value_10);
                    }
                    else {
                        return x_1;
                    }
                }, defaultArg(data.customServices, empty())), data.volte));
            }, c.status)) : singleton_1((matchValue = c.status, (matchValue == null) ? Editor__get_notChangedText(Editor_1).Value : (matchValue ? Editor__get_valueSetTrue(Editor_1).Value : Editor__get_valueSetFalse(Editor_1).Value)));
        })), react.createElement("div", {}, ...children_6))]);
    }, defaultArg(data.customServices, empty())), toList(delay(() => {
        let children_8, inputRecord, children_10;
        return isEdit ? singleton_1(ofArray([(children_8 = [render_1()((inputRecord = TextProps$1_GetDefault(), new TextProps$1((commonState[0]).CustomServiceAddingId, inputRecord.Type, inputRecord.Classes, (x_2) => {
            commonState[1]((s_3) => (new CommonState(Browser_Types_Event__Event_get_Value(x_2))));
        }, inputRecord.Disabled, inputRecord.LabelText, inputRecord.Id, inputRecord.ValidationFn, inputRecord.DynamicWidth, inputRecord.HTMLProps, inputRecord.OnBlur, inputRecord.OnFocus, inputRecord.AutoComplete, inputRecord.Name)))], react.createElement("div", {}, ...children_8)), (children_10 = [panelButton(false, "Add custom service", () => {
            setData(new ActivationStateCommon(data.data, data.dataPublicIp, data.mms, data.datapackageInMb, data.datapackageRollover, data.datapackageSpeedInKbPerSec, data.voicemail, cons(new CustomService((commonState[0]).CustomServiceAddingId, true), defaultArg(data.customServices, empty())), data.volte));
        })], react.createElement("div", {}, ...children_10))])) : singleton_1(empty());
    }))))));
}

function renderRoaming(getTranslation, isEdit, data, setData) {
    const Editor_1 = Editor_$ctor_11D407F6(getTranslation);
    return columnTable(getTranslation("Contracts.ContractType.ActivationState.RoamingHeader"), ofArray([Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.RoamingEnabled"), (value) => {
        setData(new ActivationStateRoaming(value, data.limit));
    }, data.enabled), Editor__int32Field(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.RoamingLimit"), (value_1) => {
        setData(new ActivationStateRoaming(data.enabled, value_1));
    }, data.limit)]));
}

function renderBarring(getTranslation, isEdit, data, setData) {
    const Editor_1 = Editor_$ctor_11D407F6(getTranslation);
    return columnTable(getTranslation("Contracts.ContractType.ActivationState.BarringHeader"), ofArray([Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.BarringInternationalOut"), (value) => {
        setData(new ActivationStateBarring(data.customBarrings, value, data.locked, data.outgoing, data.premium, data.roaming));
    }, data.internationalOut), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.BarringLocked"), (value_1) => {
        setData(new ActivationStateBarring(data.customBarrings, data.internationalOut, value_1, data.outgoing, data.premium, data.roaming));
    }, data.locked), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.BarringOutgoing"), (value_2) => {
        setData(new ActivationStateBarring(data.customBarrings, data.internationalOut, data.locked, value_2, data.premium, data.roaming));
    }, data.outgoing), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.BarringPremium"), (value_3) => {
        setData(new ActivationStateBarring(data.customBarrings, data.internationalOut, data.locked, data.outgoing, value_3, data.roaming));
    }, data.premium), Editor__boolField(Editor_1, isEdit, getTranslation("Contracts.ContractType.ActivationState.BarringRoaming"), (value_4) => {
        setData(new ActivationStateBarring(data.customBarrings, data.internationalOut, data.locked, data.outgoing, data.premium, value_4));
    }, data.roaming)]));
}

function renderFairusage(getTranslation, isEdit, data, setData) {
    const Editor_1 = Editor_$ctor_11D407F6(getTranslation);
    return columnTable("Fair FairUsage", ofArray([Editor__int64Field(Editor_1, isEdit, "Size In Megabytes", (value) => {
        setData(new FairUsageState(map_1(toNumber, map_1((x) => op_Multiply(op_Multiply(x, fromBits(1024, 0, false)), fromBits(1024, 0, false)), value)), data.policyId));
    }, map_1((x_1) => op_Division(op_Division(x_1, fromBits(1024, 0, false)), fromBits(1024, 0, false)), map_1((value_2) => fromNumber(value_2, false), data.ofSizeInBytes))), Editor__stringField(Editor_1, isEdit, "PolicyId", (value_3) => {
        setData(new FairUsageState(data.ofSizeInBytes, value_3));
    }, data.policyId)]));
}

class EditorState extends Record {
    constructor(IsLoading, Edit, Data, Error$) {
        super();
        this.IsLoading = IsLoading;
        this.Edit = Edit;
        this.Data = Data;
        this.Error = Error$;
    }
}

function EditorState$reflection() {
    return record_type("Containers.ActivationState.View.EditorState", [], EditorState, () => [["IsLoading", bool_type], ["Edit", option_type(ActivationState$reflection())], ["Data", ActivationState$reflection()], ["Error", option_type(string_type)]]);
}

class EditorProps extends Record {
    constructor(ClientNr, ContractTypeCode) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractTypeCode = ContractTypeCode;
    }
}

function EditorProps$reflection() {
    return record_type("Containers.ActivationState.View.EditorProps", [], EditorProps, () => [["ClientNr", int32_type], ["ContractTypeCode", string_type]]);
}

const activationStateEditor = FunctionComponent_Of_Z5A158BBF((props) => {
    let children, children_4, children_2;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const state_1 = react.useState(new EditorState(false, void 0, emptyActivationState, void 0));
    const commonState = react.useState(new CommonState(""));
    const loadData = () => singleton.Delay(() => {
        state_1[1]((x) => (new EditorState(true, x.Edit, x.Data, x.Error)));
        return singleton.Bind(API_loadActivationState(props.ClientNr, props.ContractTypeCode), (_arg) => {
            const data = _arg;
            state_1[1]((x_1) => (new EditorState(false, x_1.Edit, (data.tag === 1) ? emptyActivationState : data.fields[0], (data.tag === 1) ? data.fields[0] : (void 0))));
            return singleton.Zero();
        });
    });
    react.useEffect(() => {
        startImmediate(loadData());
    }, [props.ClientNr, props.ContractTypeCode]);
    const updateGlobal = (updater) => {
        const matchValue_1 = (state_1[0]).Edit;
        if (matchValue_1 != null) {
            const edit_1 = matchValue_1;
            state_1[1]((x_5) => (new EditorState(x_5.IsLoading, updater(edit_1), x_5.Data, x_5.Error)));
        }
    };
    let isEdit;
    const matchValue_2 = (state_1[0]).Edit;
    isEdit = (!(matchValue_2 == null));
    let activationState;
    const matchValue_3 = (state_1[0]).Edit;
    activationState = ((matchValue_3 == null) ? (state_1[0]).Data : matchValue_3);
    const matchValue_4 = (state_1[0]).Error;
    if (matchValue_4 == null) {
        if ((state_1[0]).IsLoading) {
            return dotsLoading;
        }
        else {
            const children_6 = [(children = toList(delay(() => (((state_1[0]).Edit != null) ? append(singleton_1(panelButton(false, getTranslation("Contracts.ContractType.ActivationState.Cancel"), () => {
                state_1[1]((x_4) => (new EditorState(x_4.IsLoading, void 0, x_4.Data, x_4.Error)));
            })), delay(() => singleton_1(panelButton(true, getTranslation("Contracts.ContractType.ActivationState.Save"), () => {
                let a_2, a;
                const matchValue = (state_1[0]).Edit;
                if (matchValue != null) {
                    startImmediate((a_2 = ((a = API_saveActivationState(props.ClientNr, props.ContractTypeCode, matchValue), singleton.Bind(a, (_x) => loadData()))), singleton.Delay(() => singleton.Bind(a_2, () => singleton.Return(state_1[1]((x_2) => (new EditorState(x_2.IsLoading, void 0, x_2.Data, x_2.Error))))))));
                }
            })))) : singleton_1(panelButton(true, getTranslation("Contracts.ContractType.ActivationState.Edit"), () => {
                state_1[1]((x_3) => (new EditorState(x_3.IsLoading, x_3.Data, x_3.Data, x_3.Error)));
            }))))), react.createElement("div", {
                className: "mb-4",
            }, ...children)), (children_4 = [(children_2 = [renderCommon(getTranslation, isEdit, defaultArg(activationState.commonService, emptyActivationStateCommon), (newValue) => {
                updateGlobal((x_7) => (new ActivationState(newValue, x_7.roaming, x_7.barring, x_7.fairusage)));
            }, commonState), renderRoaming(getTranslation, isEdit, defaultArg(activationState.roaming, emptyActivationStateRoaming), (newValue_1) => {
                updateGlobal((x_8) => (new ActivationState(x_8.commonService, newValue_1, x_8.barring, x_8.fairusage)));
            }), renderBarring(getTranslation, isEdit, defaultArg(activationState.barring, emptyActivationStateBarring), (newValue_2) => {
                updateGlobal((x_9) => (new ActivationState(x_9.commonService, x_9.roaming, newValue_2, x_9.fairusage)));
            }), renderFairusage(getTranslation, isEdit, defaultArg(activationState.fairusage, emptyFairUsageState), (newValue_3) => {
                updateGlobal((x_10) => (new ActivationState(x_10.commonService, x_10.roaming, x_10.barring, newValue_3)));
            })], react.createElement("div", {
                className: "activation-state__tables",
            }, ...children_2))], react.createElement("div", {}, ...children_4))];
            return react.createElement("div", {}, ...children_6);
        }
    }
    else {
        const err_2 = matchValue_4;
        return toText(printf("Error: %s"))(err_2);
    }
}, void 0, uncurry(2, void 0), void 0, "activationStateEditor", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ActivationState\\View.fs", 460);

export class ActivationStateProps extends Record {
    constructor(ClientNr, ContractTypeCode) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.ContractTypeCode = ContractTypeCode;
    }
}

export function ActivationStateProps$reflection() {
    return record_type("Containers.ActivationState.View.ActivationStateProps", [], ActivationStateProps, () => [["ClientNr", int32_type], ["ContractTypeCode", string_type]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    const children = [activationStateEditor(new EditorProps(props.ClientNr, props.ContractTypeCode))];
    return react.createElement("div", {
        className: "activation-state",
    }, ...children);
}, void 0, uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\ActivationState\\View.fs", 471);

